"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { GRID_CLASSES } from "@/libs/grid/grid";

export default function CTA() {
  return (
    <section className="w-full bg-black text-white py-16 md:py-26">
      <div className={`text-center ${GRID_CLASSES}`}>
        <div className="col-span-6 md:col-start-3 md:col-span-8 flex flex-col items-center">
          <span className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-primary-foreground/70">
            Ready to Get Started?
          </span>

          <h2 className="text-3xl font-semibold leading-tight text-primary-foreground md:text-5xl">
            Let&apos;s Find the Right Equipment Together.
          </h2>

          <p className="mt-6 max-w-2xl text-base md:text-lg leading-7 md:leading-8 text-primary-foreground/80">
            Whether you&apos;re investing in new equipment or looking for genuine spare parts, our team is ready to help you choose a solution you can depend on.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Link
              href="/shop"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-8 py-4 font-medium text-white transition hover:scale-[1.02]"
            >
              Shop Products
              <ArrowRight size={18} />
            </Link>

            <Link
              href="/contact"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-8 py-4 font-medium bg-white text-black transition"
            >
              Contact Us
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}